import type { CargaFornecedorProps } from "./types-carga-fornecedor";
import { useCargaFornecedor } from "./use-carga-fornecedor";
import { CargaFornecedorView } from "./view-carga-fornecedor";

export function CargaFornecedor(props: CargaFornecedorProps) {
  const vm = useCargaFornecedor(props);

  return <CargaFornecedorView {...vm} />;
}

export type * from "./types-carga-fornecedor";
